module.exports = __webpack_public_path__ + "media/images/footer/logo_white-7aae37ea25167b17f2a9adfd40a34090.png";